/*==============================================================

This is a barebones readonly workout component for use in places
where update/delete (and similar ops) are not needed 
(eg viewing event details in programs)

==============================================================*/

const AssignedValue = ({field,assigned})=> {

	const label = (()=>{
		switch(field){
			case "amrap": return 'reps'
			case "rep_range": return 'reps'
			default: return field
		}
	})()

	const value = (()=>{
		switch(field){
			case "amrap": return 'AMRAP'
			case "rep_range": return `${assigned.reps}-${assigned.reps_upper_limit}`
			default: return assigned[field]
		}
	})()

	return (
		<span className="d-inline-flex flex-column align-items-center ml-1">
			<small className="text-muted">{label}</small>
			<small>{Boolean(value)?value:'N/A'}</small>
		</span>
	)
}

const Exercise = ({exercise})=>{
	return (
		<div 
			className="d-flex justify-content-between pt-1 mt-1" 
			style={{borderTop:'1px solid #ccc'}}
		>
			<div>
				<small><strong>{exercise.exercise_name}</strong></small>
			</div>
			<div>
				{exercise.set_data.map(({assigned})=>(
					<div>
						{exercise.tracked_items.map(item=>(
							<AssignedValue 
								field={item} 
								assigned={assigned}
							/>
						))}
					</div>
				))}
			</div>
		</div>
	)
}

const Cardio = ({cardio})=>{

	return (
		<div 
			className="d-flex justify-content-between pt-1 mt-1" 
			style={{borderTop:'1px solid #ccc'}}
		>
			<div>
				<small><strong>{cardio.exercise_name}</strong></small>
			</div>
			<div>
				{cardio.set_data.map(({assigned})=>(
					<div>
						<AssignedValue 
							field="resistance" 
							assigned={assigned.resistance}
						/>
						<AssignedValue 
							field="distance" 
							assigned={assigned.distance}
						/>
						<AssignedValue 
							field="incline" 
							assigned={assigned.incline}
						/>
						<AssignedValue 
							field="rest" 
							assigned={assigned.rest}
						/>
						<AssignedValue 
							field="time" 
							assigned={assigned.time}
						/>
					</div>
				))}
			</div>
		</div>
	)
}

const Superset = ({sets,exercises})=>{
	return (
		<div
			className="pt-1 mt-1" 
			style={{borderTop:'1px solid #ccc'}}
		>
			<small>
				<strong className="pl-4">{sets>1?`${sets} Supersets`:'Superset'}</strong>
			</small>
			<div>
				{[...Array(sets)].map((_,i)=>(
					<div className="d-flex align-items-center">
						<small className="pr-3">{i+1}</small>
						<div style={{flex:'1 1 auto'}}>
							{exercises.map(exercise=>{
								switch(exercise.type){
									case "exercise": return (
										<Exercise 
											exercise={{...exercise,set_data:[exercise.set_data[i]]}}
										/>
									)
									case "cardio": return (
										<Cardio 
											cardio={{...exercise,set_data:[exercise.set_data[i]]}}
										/>
									)
								}
							})}
						</div>
					</div>
				))}
			</div>
		</div>
	)
}

export default function WorkoutPreview({workout}){
	//console.log(workout)
	return (
		<div style={{borderBottom:'1px solid #ccc'}} className="pb-1">
			<div>
				<strong>{workout.notes}</strong>
			</div>
			{workout.routine.map(({type,exercises,sets})=>{
				switch(type){
					case "exerciseSingleton": return <Exercise exercise={exercises[0]}/>
					case "cardioSingleton": return <Cardio cardio={exercises[0]}/>
					case "superset": return <Superset exercises={exercises} sets={sets}/>
				}
			})}
		</div>
	)
}